export default __webpack_public_path__ + "static/media/coalogo.29807f6b.png";